export const FETCH_INDUSTRIES = "FETCH_INDUSTRIES";